import {
  fetchList,
  fetchApp,
  postNewApp,
  deleteApp,
  updateApp,
  fetchListRequests,
  fetchListCallbacks
} from "@/api/appApi";
import { getToken } from "@/util/auth";

const state = {
  listItems: [],
  total: 0,
  listRequests: [],
  totalRequests: 0,
  listCallbacks: [],
  totalCallbacks: 0
};

const mutations = {
  SET_LIST_APPS: (state, data) => {
    state.listItems = data;
  },
  SET_TOTAL_APPS: (state, data) => {
    state.total = data;
  },
  SET_LIST_REQUESTS: (state, data) => {
    state.listRequests = data;
  },
  SET_TOTAL_REQUESTS: (state, data) => {
    state.totalRequests = data;
  },
  SET_LIST_CALLBACKS: (state, data) => {
    state.listCallbacks = data;
  },
  SET_TOTAL_CALLBACKS: (state, data) => {
    state.totalCallbacks = data;
  }
};

const actions = {
  fetchListApp({ commit }, query) {
    return new Promise((resolve, reject) => {
      if (getToken()) {
        fetchList(query)
          .then(response => {
            if (query) {
              commit("SET_LIST_APPS", response.data);
              commit("SET_TOTAL_APPS", parseInt(response.headers["total"]));
            }
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          });
      } else {
        reject();
      }
    });
  },
  fetchListRequest({ commit }, query) {
    return new Promise((resolve, reject) => {
      fetchListRequests(query)
        .then(response => {
          commit("SET_LIST_REQUESTS", response.data);
          commit("SET_TOTAL_REQUESTS", parseInt(response.headers["total"]));
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchListCallback({ commit }, query) {
    return new Promise((resolve, reject) => {
      fetchListCallbacks(query)
        .then(response => {
          commit("SET_LIST_CALLBACKS", response.data);
          commit("SET_TOTAL_CALLBACKS", parseInt(response.headers["total"]));
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  fetchAppDetail({ commit }, id) {
    return new Promise((resolve, reject) => {
      fetchApp(id)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteApp({ commit }, id) {
    return new Promise((resolve, reject) => {
      deleteApp(id)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateApp({ commit }, data) {
    return new Promise((resolve, reject) => {
      updateApp(data)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  createNewApp({ commit }, data) {
    return new Promise((resolve, reject) => {
      postNewApp(data)
        .then(response => {
          resolve();
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

const order = {
  state,
  mutations,
  actions,
  getters: {
    listApps: state => state.listItems,
    totalApps: state => state.total,
    listRequests: state => state.listRequests,
    totalRequests: state => state.totalRequests,
    listCallbacks: state => state.listCallbacks,
    totalCallbacks: state => state.totalCallbacks
  }
};

export default order;
